import {createReducer} from '../../base/fsa/createReducer';
import {initialSetupState} from './state';
import {addRawDeviceAction, clearRawDevicesAction, removeRawDeviceAction} from './actions';

export const setupReducer = createReducer(initialSetupState, handle => [
    handle(addRawDeviceAction, (state, action) => {
        const originalRawDevice = state.rawDeviceList.find(device => device.unique_device_id === action.payload.rawDevice.unique_device_id && device.gateway_id === action.payload.rawDevice.gateway_id);
        if (originalRawDevice == null) {
            return {
                ...state,
                rawDeviceList: [...state.rawDeviceList, action.payload.rawDevice],
            };
        }

        return {
            ...state,
            rawDeviceList: state.rawDeviceList.map(device => {
                if (device.unique_device_id === action.payload.rawDevice.unique_device_id && device.gateway_id === action.payload.rawDevice.gateway_id) {
                    return action.payload.rawDevice;
                }

                return device;
            }),
        };
    }),
    handle(removeRawDeviceAction, (state, action) => {
        const index = state.rawDeviceList.indexOf(action.payload.rawDevice);
        if (index > -1) {
            return {
                ...state,
                rawDeviceList: [
                    ...state.rawDeviceList.slice(0, index),
                    ...state.rawDeviceList.slice(index + 1),
                ],
            };
        } else {
            return state;
        }
    }),
    handle(clearRawDevicesAction, state => {
        return {
            ...state,
            rawDeviceList: [],
        };
    }),
]);
